import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/ProjectsAndVessels/Ship/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { v3_add_ship } from '../../../actions/v3/projectAndVessel'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_ship(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listShipMasterData.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Vessel'}
            >
                <Form
                    title={'Add Vessel'}
                    onSubmit={onSubmit}
                    buttonName={'Create Vessel'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add